import { type LDSingleKindContext, initialize } from 'launchdarkly-js-client-sdk';
import { type Auth, getAuth } from '@harbortouch/alexandria-utilities';

export const checkTokenExpired = () => {
	const token = getAuth()?.authenticated;
	const currentTime = Date.now() / 1000;
	return token && token.exp < currentTime;
};

export const initializeLaunchDarkly = async (token: Auth['authenticated']) => {
	const user: LDSingleKindContext = {
		kind: 'user',
		key: `${token.sub}`,
		email: token.email,
		name: '',
		custom: {
			customerName: `${token.firstName} ${token.lastName}`.trim(),
		},
	};
	// TODO Refactor to use dotenv
	const ldClientId = process.env.NODE_ENV === 'production' ? '614022e9694e8d262b59f82f' : '62695639cb0596159e560770';
	const client = initialize(ldClientId, user);
	await client.waitUntilReady();
	return client;
};
